import { useLocation } from "react-router-dom";
import { LargeContentBox } from "../../components/common";
import { CreateProtocolContent } from "./CreateProtocolContent";
import { Stack } from "@mui/material";
import { PageHeader } from "@/components/common/PageHeader";
import { NoteAddRounded } from "@mui/icons-material";

export function CreateProtocol() {
  const { state } = useLocation();
  return (
    <LargeContentBox>
      <Stack sx={{ width: "100%" }}>
        <PageHeader
          title={
            state?.defaultItens
              ? state?.defaultItens?.display
              : "Criar protocolo"
          }
          icon={NoteAddRounded}
          centered
        />

        <CreateProtocolContent
          id={state?.id}
          defaultItens={state?.defaultItens}
        />
      </Stack>
    </LargeContentBox>
  );
}
